import { createSlice } from "@reduxjs/toolkit";
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    dashboardDataRequest: (state) => {
      state.isFetching = true;
    },
    dashboardDataSuccess: (state, action) => {
      state.isFetching = false;
      state.data = action.payload;
    },
    dashboardDataFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});
export const {
  dashboardDataRequest,
  dashboardDataSuccess,
  dashboardDataFailure,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
